import type { FC, ReactNode } from 'react';

import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';
import type { TypographyVariant } from 'src/app/components/Elements/Typography';
import { Typography } from 'src/app/components/Elements/Typography';
import { CAPSULE_ICON_STRINGS } from 'src/consts';

import { InlineBlockContent, SuccessBody, SuccessCTATextButton, TryAgainButton } from './styles';

interface ZipDeliverableContentProps {
  clearZipCheckStatus: () => void;
  headerSize: TypographyVariant;
  successBody?: ReactNode;
  lastCheckedZip: string;
  successCTAOnClick?: () => void;
  onRedirectToOnboarding: () => void;
  successCTAText: string;
  CTATheme?: 'capsuleGreen60';
}

export const ZipDeliverableContent: FC<ZipDeliverableContentProps> = ({
  clearZipCheckStatus,
  headerSize,
  successBody,
  lastCheckedZip,
  successCTAText,
  successCTAOnClick,
  onRedirectToOnboarding,
  CTATheme,
}) => {
  return (
    <>
      <TryAgainButton onClick={clearZipCheckStatus} style={'inlineLink'} size={'noPadding'}>
        <CapsuleIcon iconString={CAPSULE_ICON_STRINGS.system_nav_back_arrow} raw />
        <Typography variant={'overline'} color={'white'} marginBottom={'none'}>
          Try Another
        </Typography>
      </TryAgainButton>
      <Typography variant={headerSize} color={'white'} marginBottom={successBody ? 's5' : 's7'}>
        Good news, {lastCheckedZip} is in our <InlineBlockContent>delivery area.</InlineBlockContent>
      </Typography>
      {successBody && (
        <SuccessBody variant={'h3'} color={'white'} marginBottom={'s7'}>
          {successBody}
        </SuccessBody>
      )}
      <SuccessCTATextButton
        bgColor={CTATheme}
        style={'primary'}
        size={'medium'}
        onClick={successCTAOnClick ?? onRedirectToOnboarding}
      >
        {successCTAText}
      </SuccessCTATextButton>
      );
    </>
  );
};
